/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Campus_Callout_LinkInputs */

const en_dr_campus_callout_link = /** @type {(inputs: Dr_Campus_Callout_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Design Room`)
};

const id_dr_campus_callout_link = /** @type {(inputs: Dr_Campus_Callout_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Design Room`)
};

/**
* | output |
* | --- |
* | "See Design Room" |
*
* @param {Dr_Campus_Callout_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_campus_callout_link = /** @type {((inputs?: Dr_Campus_Callout_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Campus_Callout_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_campus_callout_link(inputs)
	return en_dr_campus_callout_link(inputs)
});